<div *ngIf="showWelcomeScreen"
    class="flex flex-col items-center justify-start h-screen w-screen bg-gradient-to-r   bg-black   p-0 overflow-clip  relative z-50 " style="z-index: 1000;">

<div class="bg-black w-full h-full fixed">

</div>
    <img [src]="selectedBackgroundImage" id="wallpaper" class="w-screen h-screen  absolute animate__animated animate__fadeIn "
        style="object-fit: cover; transition: all 1.2s ease-out;">

    <section class="absolute">
        <video autoplay loop
            src="https://video.wixstatic.com/video/d47472_58cce06729c54ccb935886c4b3647274/1080p/mp4/file.mp4"
            class="w-screen h-screen z-10 mix-blend-screen tint" style="		object-fit: cover;
					object-position: center;
					left: 0;
					top: 0;
					right: 0;" autoplay muted  playsinline webkit-playsinline disablePictureInPicture></video>

    </section>



    <video autoplay loop
        src="https://static.videezy.com/system/resources/previews/000/002/333/original/bonfire-sparks.mp4"
        class="w-screen h-screen z-10 mix-blend-lighten absolute  " style="		object-fit: cover;
					object-position: center;
					left: 0;
					top: 0;
					right: 0;" autoplay muted  playsinline webkit-playsinline disablePictureInPicture></video>



    <h1 id="welcome-text"
        class="absolute text-[35px]  sm:text-[40px]    md:text-[60px]  text-white text-center  font-[900]   mt-20   w-full md:w-[700px]  leading-[60px] md:leading-[88px]    font-mono ">
        Power Up Your Play. Upgrade <span class="marck-script-regular"><br>Your Day<br></span>. Only at Softnet Computers!
    </h1>
 

    <div [style.background-image]="'url(' + selectedCharacterImage + ')'" id="wavatar"
        class="  h-screen absolute z-20  bg-bottom    w-[200vw] md:w-[100vw]  animate__animated animate__fadeIn animate__delay-1s"
        style="transition: all 2s ease-out;   background-repeat: no-repeat;  background-size: cover;   ">

    </div>
 

    <h1 id="welcome-text"
        class="absolute  text-[35px]  sm:text-[40px]   md:text-[60px]   text-center  font-[900] z-30   mt-20  w-full md:w-[700px]  leading-[60px] md:leading-[88px]      text-transparent items-start font-mono  ">
        Power Up Your Play. Upgrade <span class="marck-script-regular"><br>Your Day<br></span>. Only at Softnet Computers!
    </h1>



 


    <div class="absolute bottom-12 z-50 flex flex-col justify-center">
        <div class="flex flex-row items-center justify-center gap-2">
            <button class="button-49 z-20" (click)="close()" role="button">VISIT THE STORE</button>


        </div>

        <div class="  w-full z-[2000]  p-8">


            <div class=" w-full rounded-lg  pt-4   shadow-xl backdrop-blur-sm  bg-black/20 flex flex-row justify-items-center gap-3 items-center justify-center text-white"
                style="border-style: solid; border-width: .4px; border-color: black;">
                <span class="p-4 py-1">
                    <a [routerLink]="[cat1.slug]" (click)="close()"
                        class="     text-white flex flex-col justify-center rounded items-center gap-2  max-w-36 text-center">

                        <img [alt]="'click. all products for the category ' + cat1!.label!"
                            [ariaLabel]="'click. all products for the category ' + cat1!.label"
                            [src]="getIcon(cat1!.icon!)" loading="lazy" class="aspect-square" style="
              width: 38px;
              height: 38px;
              object-fit: contain;
              object-position: center;
              filter: saturate(1.2);
            " />

                        <span class="h-14"> {{ cat1!.label!}}</span>
                    </a>

                </span>
                <hr class="vl">
                <span class="p-4 py-1">
                    <a [routerLink]="[cat2.slug]" (click)="close()"
                        class="     text-white flex flex-col justify-center rounded items-center gap-2 max-w-36 text-center">

                        <img [alt]="'click. all products for the category ' + cat2!.label!"
                            [ariaLabel]="'click. all products for the category ' + cat2!.label"
                            [src]="getIcon(cat2!.icon!)" loading="lazy" class="aspect-square" style="
              width: 38px;
              height: 38px;
              object-fit: contain;
              object-position: center;
              filter: saturate(1.2);
            " />

                        <span class="h-14"> {{ cat2!.label!}}</span>
                    </a>

                </span>

                <hr class="vl">
                <span class="p-4 py-1">
                    <a [routerLink]="[cat3.slug]" (click)="close()"
                        class="     text-white flex flex-col justify-center rounded items-center gap-2 max-w-36 text-center">

                        <img [alt]="'click. all products for the category ' + cat3!.label!"
                            [ariaLabel]="'click. all products for the category ' + cat3!.label"
                            [src]="getIcon(cat3!.icon!)" loading="lazy" class="aspect-square" style="
              width: 38px;
              height: 38px;
              object-fit: contain;
              object-position: center;
              filter: saturate(1.2);
            " />

                        <span class="h-14"> {{ cat3!.label!}}</span>
                    </a>

                </span>

            </div>



        </div>
    </div>
 <!--                                               -->

    <div class="vignette z-10 w-screen h-screen"></div>
    <div class="vignette z-10 w-screen h-screen"></div> 

</div>






<!-- <h1 class="text-4xl font-bold text-white mb-4">Welcome to Softnet Computers</h1>
    <p class="text-lg text-gray-300 mb-6">Your one-stop solution for all computer needs.</p>
    <button (click)="showWelcomeScreen = false" class="bg-[#ff4d06] text-white px-6 py-2 rounded hover:bg-red-600">
      Get Started
    </button> -->
